import CheckCircle from '@/public/icons/check-circle.svg'
import { Button, Modal } from '@lockerpm/design'
import Image from 'next/image'
import { EXTERNAL_URL } from '../../../config/externalUrl'
export default function ModalCopied({ isOpen, closeModal }) {
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      className="modal-copied-password w-[900px]"
      onCancel={closeModal}
    >
      <div className="md:pt-16 pt-8 pl-4 md:pl-11 copy-password-modal-content relative">
        <div className="w-fit py-[6px] mb-6 px-3 flex items-center gap-2 border border-solid border-primary-600 rounded-lg text-primary-600 font-semibold text-[15px] leading-8">
          <CheckCircle />
          <span>Đã sao chép</span>
        </div>
        <div className="flex md:flex-row flex-col md:gap-0 gap-6">
          <div className="max-w-[480px] flex-shrink-0 md:pr-0 pr-4">
            <h3 className="text-heading mb-3 font-semibold text-display-sm md:text-[40px] md:leading-[52px]">
              Tạm biệt nỗi lo phải ghi nhớ mật khẩu với Locker
            </h3>
            <p className="text-base text-gray-700 font-medium">
              Đăng ký miễn phí, không cần thẻ tín dụng
            </p>
            <a href={EXTERNAL_URL.REGISTER} target="_blank" rel="noopener noreferrer">
              <Button type="primary" className="font-semibold rounded-lg mt-12" size="large">
                Tạo tài khoản ngay
              </Button>
            </a>
          </div>
          <div className="flex-1 relative">
            <Image
              src={'/images/password-generator/ModalCopyDesktop.svg'}
              alt="Locker password generator"
              className="w-full"
              width={450}
              height={350}
            />
            <Image
              src={'/images/password-generator/ModalCopyPhone.svg'}
              alt="Locker password generator"
              className="absolute left-0 md:-left-16 bottom-0 w-fit"
              width={120}
              height={240}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}
